<script>


  import {totalViewCountView} from "../static";
  import {External, M} from "../../external";

  export let videoFolderData = {};
  export let selectFolder;
  export let removeFolder;
  export let showSelectFolder = false;
  export let onSelectFolderContent = () => {};


  export let renameFolder = (id) => {};

  let optionsInstance;
  let availableOptions = {
    rename: {
      text: M.RENAME,
      icon: "fa-edit",
      tag: "rename"
    },
    delete: {
      text: M.DELETE,
      icon: "fa-trash",
      tag: "delete"
    },
    loading: {
      text: M.LOADING,
      icon: "fa-spinner",
      tag: "loading"
    }
  }

  let onOptionsClick = () => {
    let items = [];
    items.push(availableOptions.rename);
    items.push(availableOptions.delete);
    External.Tools.showTooltipOptions(optionsInstance, items, (target, idx, text, tag) => {
      switch (tag) {
        case 'rename':
          renameFolder(videoFolderData.id);
          break;
        case 'delete':
          removeFolder(videoFolderData.name, videoFolderData.id)
          break;
      }
    });
  }

</script>

<div class="video-object crm-folder col20 f-left flex align center space-between" on:click={() => selectFolder(videoFolderData)}>
  <div class="flex align-center">
    <div class="crm-folder-icon">
      <span class="material-icons-outlined">subscriptions</span>
    </div>
    <div class="crm-folder-info">
      <h3>{videoFolderData.name}</h3>
      <span class="video-stat-wrapper">{videoFolderData.videoCount} {M.VIDEOS}</span>
    </div>
  </div>
  <div class="crm-folder-stats flex align-center flex-none">
<!--    <a class="small-button blue rounded-effect mr-5 visibility-hidden" on:click|stopPropagation={() => renameFolder(videoFolderData.id)}>Rename</a>-->
<!--    <a class="small-button blue rounded-effect mr-5 ml-0 visibility-hidden"-->
<!--       on:click|stopPropagation={() => {removeFolder(videoFolderData.name, videoFolderData.id)}}>Delete</a>-->
    {#if showSelectFolder}
      <a class="small-button blue rounded-effect mr-5 visibility-hidden" on:click|stopPropagation={() => onSelectFolderContent(videoFolderData)}>{M.SELECT}</a>
    {/if}
    <div class="f-left flex-centered">
      <a class="circle-button-small rounded-effect mr-5" on:click|stopPropagation={onOptionsClick} bind:this={optionsInstance}>
        <i class="fa-solid fa-ellipsis"></i>
      </a>
    </div>
    <div class="crm-folder-info-wrapper">{totalViewCountView(videoFolderData.totalViews)} <p>{M.VIEWS}</p>
    </div>
  </div>
  <!--<div class="hide-video-object-btn crm-folder-stats flex align-center close">
    <button class="middle-button red rounded-effect" on:click={() => {removeFolder(videoFolderData.name)}}>
      <span class="material-icons-outlined">delete</span>
    </button>
  </div>-->
</div>

<style>

  .hide-video-object-btn {
    visibility: hidden;
  }

  .video-object:hover > .hide-video-object-btn {
    visibility: visible;
  }
</style>
